/*!
 * @piconetworks/tooltip v2.1.28
 * (c) 
 */
'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var Tippy = require('@tippyjs/react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var Tippy__default = /*#__PURE__*/_interopDefaultLegacy(Tippy);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Trigger = /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default['default'].createElement("span", {
    ref: ref
  }, children);
});

var Tooltip = function Tooltip(props) {
  var placement = props.placement,
      className = props.className,
      children = props.children,
      label = props.label,
      content = props.content;
  return /*#__PURE__*/React__default['default'].createElement(Tippy__default['default'] // to debug styles, add prop to Tippy trigger="click"
  , _extends({
    arrow: true,
    content: content || label,
    className: className,
    placement: placement,
    theme: "pico"
  }, props), /*#__PURE__*/React__default['default'].createElement(Trigger, null, children));
};

Tooltip.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  content: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].node]),
  label: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].node]),
  placement: PropTypes__default['default'].oneOf(['top', 'right', 'bottom', 'left', 'top-start', 'top-end', 'right-start', 'right-end', 'bottom-start', 'bottom-end', 'left-start', 'left-end', 'auto', 'auto-start', 'auto-end'])
};
Tooltip.defaultProps = {
  className: '',
  placement: 'auto'
};

module.exports = Tooltip;
